import * as React from 'react';
import { InputSearch } from '../InputSearch/InputSearch.js';
import type { ProductGridItem } from './ProductGrid.js';

export const searchFn = (searchString: string) => (item: ProductGridItem) => {
  if (searchString === '') {
    return true;
  }
  const searchKeywords = searchString.toLowerCase().split(' ');
  const searchableKeywords = [...item.name.split(' '), item.manufacturer, ...(item.tags || [])].map(keyword =>
    keyword.toLowerCase()
  );
  return searchKeywords.every(searchKeyword =>
    searchableKeywords.some(searchableKeyword => searchableKeyword.includes(searchKeyword))
  );
};

export interface ProductGridSearchCLProps {
  onChange: (newValue: string) => void;
  value: string;
  placeholder: string;
}

export const ProductGridSearchCL = ({ onChange, placeholder, value }: ProductGridSearchCLProps) => (
  <div className="of-product-grid-search">
    <InputSearch
      placeholder={placeholder}
      onChange={(e: React.SyntheticEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
      value={value}
      noSubmit={true}
    />
  </div>
);
